<template lang="html">
        <div id="page__price-search" class="toolbar-search">
            <z-select
                v-model="filter.type"
                name="filter_city-type"
                id="filter_city-type"
                v-on:input="onFilter" light
            >
                <option value="" selected> Тип расчета (любой) </option>
                <option v-bind:value="1"> По весу </option>
                <option v-bind:value="2"> По объему </option>
            </z-select>
            <z-input-autocomplete
                class="search-autocomplete" light
                placeholder="Отправление (введите город или направление)"
                display-property="label"
                property="name"  v-bind:callback="find"
                v-on:clear="clearFrom"
                v-on:select="selectFrom"
                ref="from"
                return="id" v-on:keyup.enter="onFilter"
                v-model="from"
                id="deal_filter_from"
                name="deal_filter_from"
                v-bind:error="errors.first('deal_filter_from')"
                data-vv-name="deal_filter_from"
                v-bind:data-vv-as="' '"
                noResize
            ></z-input-autocomplete>

            <z-input-autocomplete
                class="search-autocomplete" light
                placeholder="Назначение (введите город или направление)"
                display-property="label"
                property="name"
                return="id" v-on:keyup.enter="onFilter"
                v-model="to" 
                v-bind:callback="find"
                v-on:clear="clearTo"
                v-on:select="selectTo"
                id="deal_filter_to"
                name="deal_filter_to"
                v-bind:error="errors.first('deal_filter_to')"
                data-vv-name="deal_filter_to"
                v-bind:data-vv-as="' '"
                ref="to"
                noResize
            ></z-input-autocomplete>
            <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-bind:disabled="!hasFilter" v-on:click="onReset"></z-icon-button>
        </div>
</template>
<script>
    import ToggleMenu from '@/components/ToggleMenu';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    import ClickOutside from 'vue-click-outside';
    import ZSelect from '@/components/ZSelect';
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: {ToggleMenu, ZInputAutocomplete, ZSelect, ZIconButton},
        directives: {ClickOutside},
        data() {
            return {
                loading: false,
                from: null,
                to: null,
                filter: {
                    type: '',
                    city_id_from: null,
                    city_id_to: null,
                    zone_id_from: null,
                    zone_id_to: null,
                },
                filterDefault: {
                    type: '',
                    city_id_from: null,
                    city_id_to: null,
                    zone_id_from: null,
                    zone_id_to: null,
                }
            }
        },
        created() {
            this.resolveQueryFilter();
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            },
        },
        watch: {},
        methods: {
            /**
             * Перебор городов и зон
             */
            find(value) {
                if (!value || value.length < 3) return new Promise(resolve => resolve([]));
                return Promise.all([this.getCities(value), this.getZones(value)]).then(data => {
                    let result = [];
                    if (!data || !data.length) return result;
                    data.map(dataArr => {
                        if (dataArr && dataArr instanceof Array && dataArr.length) result = result.concat(dataArr);
                    });
                    return result;
                }).catch(() => []);
            },
            /**
             * Получение городов
             */
            getCities(value) {
                let filter = {model: [['name', '%', value]]};
                return this.$store.dispatch('cost/getCitiesNew', {page: 1, order_by: 'name', order_type: 'asc', count: 20, filter: filter}).then(result => {
                    if (!result || !result.data) return [];
                    return result.data.map(city => {
                        city.type = 'city';
                        city.label = 'Город: ' + city.name;
                        return city;
                    });
                });
            },
            /**
             * Получение зон
             */
            getZones(value) {
                return this.$store.dispatch('stock/getZones', { name: value }).then(r => {
                    if (!r) return [];
                    return r.map(zone => {
                        zone.type = 'zone';
                        zone.label = 'Направление: ' + zone.name;
                        return zone;
                    });
                });
            },
            /**
             * Выбор отправления
             */
            selectFrom(i, item) {
                if (!item || !item.type || !item.id) return;
                this.filter.city_id_from = null;
                this.filter.zone_id_from = null;

                if (item.type == 'city') this.filter.city_id_from = item.id;
                else if (item.type == 'zone') this.filter.zone_id_from = item.id;
                else return;

                this.onFilter();
            },
            /**
             * Выбор назначения
             */
            selectTo(i, item) {
                if (!item || !item.type || !item.id) return;
                this.filter.city_id_to = null;
                this.filter.zone_id_to = null;

                if (item.type == 'city') this.filter.city_id_to = item.id;
                else if (item.type == 'zone') this.filter.zone_id_to = item.id;
                else return;

                this.onFilter();
            },
            /**
             * Очистка отправления
             */
            clearFrom() {
                this.filter.city_id_from = null;
                this.filter.zone_id_from = null;
                this.onFilter();
            },
            /**
             * Очистка назначения
             */
            clearTo() {
                this.filter.city_id_to = null;
                this.filter.zone_id_to = null;
                this.onFilter();
            },
            /**
             * Фильтрация
             */
            onFilter() {
                this.$router.push({ 
                    name: this.$route.name, 
                    params: this.$route.params, 
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });
                this.$root.$emit('refresh-table', 'prices');
            },
            /**
             * Подставление фильтра при перезагрузки страницы
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return;
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter));
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                let query = Object.assign({}, this.$route.query);
                delete query.filter;

                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: Object.assign({}, query)
                });
                this.$root.$emit('refresh-table', 'prices');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// PriceToolbar.vue?62ba7b30